<div class="acc-tap" *ngIf="step === 'form'">
  <h3 class="acc-tap-title">{{ "changeEmail" | translate }}</h3>
  <hr class="m-0" />
  <form
    [formGroup]="emailForm"
    (ngSubmit)="onSubmit()"
    class="space-y-4"
  >
    <div class="acc-tap-content">
      <!-- Current Email -->
      <div class="form-group">
        <label
          for="currentEmail"
          [class]="
            emailForm.controls['currentEmail'].touched
              ? emailForm.controls['currentEmail'].valid
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "currentEmailLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="email"
          id="currentEmail"
          formControlName="currentEmail"
          class="form-control border rounded w-full p-2"
          maxlength="100"
          autocomplete="email"
          [ngClass]="{
            'border-red-500':
              emailForm.controls['currentEmail'].touched &&
              emailForm.controls['currentEmail'].invalid,
            'border-green-500':
              emailForm.controls['currentEmail'].touched &&
              emailForm.controls['currentEmail'].valid
          }"
        />

        <span
          *ngIf="emailForm.controls['currentEmail'].touched"
          [ngClass]="{
            'text-red-500': emailForm.controls['currentEmail'].invalid,
            'text-green-500': emailForm.controls['currentEmail'].valid
          }"
          class="text-sm"
        >
          <ng-container *ngIf="emailForm.controls['currentEmail'].errors?.['required']">
            {{ "currentEmailRequired" | translate }}
          </ng-container>
          <ng-container
            *ngIf="
              emailForm.controls['currentEmail'].value &&
              emailForm.controls['currentEmail'].errors?.['emailMismatch']
            "
          >
            {{ "emailMismatch" | translate }}
          </ng-container>
          <ng-container *ngIf="emailForm.controls['currentEmail'].errors?.['email']">
            {{ "emailInvalidError" | translate }}
          </ng-container>
        </span>
      </div>

      <!-- New Email -->
      <div class="form-group">
        <label
          for="newEmail"
          [class]="
            emailForm.controls['newEmail'].touched
              ? emailForm.controls['newEmail'].valid
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "newEmailLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="email"
          id="newEmail"
          formControlName="newEmail"
          class="form-control border rounded w-full p-2"
          maxlength="100"
          autocomplete="off"
          [ngClass]="{
            'border-red-500':
              emailForm.controls['newEmail'].touched &&
              emailForm.controls['newEmail'].invalid,
            'border-green-500':
              emailForm.controls['newEmail'].touched &&
              emailForm.controls['newEmail'].valid
          }"
        />

        <span
          *ngIf="
            emailForm.controls['newEmail'].touched &&
            emailForm.controls['newEmail'].errors
          "
          [ngClass]="{
            'text-red-500': emailForm.controls['newEmail'].invalid,
            'text-green-500': emailForm.controls['newEmail'].valid
          }"
          class="text-sm"
        >
          <ng-container *ngIf="emailForm.controls['newEmail']?.errors?.['required']">
            {{ "newEmailRequired" | translate }}
          </ng-container>
          <ng-container *ngIf="emailForm.controls['newEmail']?.errors?.['email']">
            {{ "emailInvalidError" | translate }}
          </ng-container>
          <ng-container *ngIf="emailForm.controls['newEmail'].getError('emailDomainTypo') as typo">
            {{ 'step6.emailDomainTypo' | translate:typo }}
          </ng-container>
        </span>
      </div>
    </div>

    <div *ngIf="apiError" class="text-red-500 text-sm mb-2 d-flex justify-content-center">
      {{ apiError }}
    </div>

    <hr class="m-0" />
    <div class="acc-tap-footer">
      <button type="submit" class="main-btn">
        <i class="fa-regular fa-pen-to-square"></i>
        {{ "save" | translate }}
      </button>
    </div>
  </form>
</div>

<div class="acc-tap" *ngIf="step === 'otp'">
  <h3 class="acc-tap-title">{{ "verifyOTP" | translate }}</h3>
  <hr class="m-0" />
  <div class="acc-tap-content">
    <div class="otp-container">
      <p class="otp-description">
        {{ "otpSentToEmail" | translate }}:
        <strong class="email-display">{{ otpDestinationEmail }}</strong>
      </p>
      <app-otp-input
        [phoneNumber]="phoneNumber"
        [hideDestination]="true"
        [generateNewOtp]="false"
        [operationType]="4"
        (onValidationSuccess)="handleOtpSuccess($event)"
        (onValidationFailed)="handleOtpFailed($event)"
      ></app-otp-input>
    </div>
  </div>
  <div *ngIf="apiError" class="text-red-500 text-sm mb-2 d-flex justify-content-center mt-3">
    {{ apiError }}
  </div>
</div>
